class HotelCEMCommonFilterEntity {
  dateRange = []
  hotelInfo = {}

  constructor({ hotelInfo = [], dateRange = [] }) {
    this.hotelInfo = hotelInfo
    this.dateRange = dateRange
  }
}

export default HotelCEMCommonFilterEntity
